import { useEffect, useState } from 'react';

const MOBILE_MAX = 767;

export type Breakpoint = 'mobile' | 'desktop';

export function useBreakpoint(): Breakpoint {
  const [bp, setBp] = useState<Breakpoint>(() =>
    typeof window !== 'undefined' && window.innerWidth <= MOBILE_MAX ? 'mobile' : 'desktop'
  );

  useEffect(() => {
    const handler = () => {
      setBp(window.innerWidth <= MOBILE_MAX ? 'mobile' : 'desktop');
    };
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  return bp;
}
